import React, { useEffect, useState } from 'react';
export function CountdownSection() {
  // Simple static countdown for visual purposes as requested
  const [timeLeft, setTimeLeft] = useState({
    hours: 23,
    minutes: 59,
    seconds: 44
  });
  useEffect(() => {
    const timer = setInterval(() => {
      setTimeLeft(prev => {
        if (prev.seconds > 0) {
          return {
            ...prev,
            seconds: prev.seconds - 1
          };
        } else if (prev.minutes > 0) {
          return {
            ...prev,
            minutes: prev.minutes - 1,
            seconds: 59
          };
        } else if (prev.hours > 0) {
          return {
            hours: prev.hours - 1,
            minutes: 59,
            seconds: 59
          };
        }
        return prev;
      });
    }, 1000);
    return () => clearInterval(timer);
  }, []);
  return <section className="bg-gray-900 py-5 sm:py-8 px-4 sm:px-6 lg:px-8 border-y-4 border-agua" data-id="element-68">
      <div className="max-w-4xl mx-auto flex flex-col items-center text-center" data-id="element-69">
        <h3 className="text-yellow-400 font-bold text-lg sm:text-xl mb-3 sm:mb-4 uppercase tracking-wider" data-id="element-70">
          EL PRECIO DE LANZAMIENTO TERMINA EN:
        </h3>

        <div className="flex items-center justify-center gap-3 sm:gap-6 mb-4 sm:mb-6" data-id="element-71">
          <div className="flex flex-col items-center" data-id="element-72">
            <div className="bg-agua text-white text-2xl sm:text-5xl font-black rounded-lg w-14 h-14 sm:w-24 sm:h-24 flex items-center justify-center shadow-lg" data-id="element-73">
              {String(timeLeft.hours).padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-xs sm:text-sm mt-2 font-medium uppercase" data-id="element-74">
              Horas
            </span>
          </div>
          <span className="text-white text-2xl sm:text-5xl font-black pb-6" data-id="element-75">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-76">
            <div className="bg-agua text-white text-2xl sm:text-5xl font-black rounded-lg w-14 h-14 sm:w-24 sm:h-24 flex items-center justify-center shadow-lg" data-id="element-77">
              {String(timeLeft.minutes).padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-xs sm:text-sm mt-2 font-medium uppercase" data-id="element-78">
              Minutos
            </span>
          </div>
          <span className="text-white text-2xl sm:text-5xl font-black pb-6" data-id="element-79">
            :
          </span>
          <div className="flex flex-col items-center" data-id="element-80">
            <div className="bg-agua text-white text-2xl sm:text-5xl font-black rounded-lg w-14 h-14 sm:w-24 sm:h-24 flex items-center justify-center shadow-lg" data-id="element-81">
              {String(timeLeft.seconds).padStart(2, '0')}
            </div>
            <span className="text-gray-400 text-xs sm:text-sm mt-2 font-medium uppercase" data-id="element-82">
              Segundos
            </span>
          </div>
        </div>

        <p className="text-white text-lg sm:text-xl font-medium mb-3 sm:mb-4" data-id="element-83">
          Después sube <span className="text-agua font-bold" data-id="element-84">$8.000 ARS</span> y
          no vuelve a bajar.
        </p>

        <div className="w-full max-w-md" data-id="element-85">
          <div className="flex justify-between text-xs text-gray-400 mb-1 font-medium" data-id="element-86">
            <span data-id="element-87">Cupos al precio de lanzamiento</span>
            <span data-id="element-88">68% tomados</span>
          </div>
          <div className="w-full bg-gray-800 rounded-full h-3 overflow-hidden" data-id="element-89">
            <div className="bg-agua h-3 rounded-full" style={{
            width: '68%'
          }} data-id="element-90"></div>
          </div>
        </div>
      </div>
    </section>;
}